/*
 * file-attachment (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { fileAttachments } from "./file-attachment.schema"

export type FileAttachment = z.infer<typeof selectFileAttachmentSchema>
export const selectFileAttachmentSchema = createSelectSchema(fileAttachments)

export type FileAttachmentFilters = z.infer<typeof fileAttachmentFiltersSchema>
export const fileAttachmentFiltersSchema = z.object({
	id: z.string().optional(),
	entityType: z.string().optional(),
	entityId: z.string().optional(),
	patientId: z.string().optional(),
	attachmentTypeId: z.string().optional(),
	active: z.boolean().optional(),
})

export const createFileAttachmentSchema = createInsertSchema(fileAttachments).partial(
	globalCreateExclude,
)
export type CreateFileAttachment = z.infer<typeof createFileAttachmentSchema>

export const updateFileAttachmentSchema = createInsertSchema(fileAttachments)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateFileAttachment = z.infer<typeof updateFileAttachmentSchema>
